import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detectchange',
  templateUrl: './detectchange.component.html',
  styleUrls: ['./detectchange.component.css']
})
export class DetectchangeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
